export function formatTimeRange(timestamp, timeRangeUnit, timeRangePosition = "end") {
  const currentTime = new Date(timestamp);
  const startTime = timeRangePosition === "start"
    ? currentTime
    : new Date(currentTime.getTime() - timeRangeUnit);
  const endTime = timeRangePosition === "start"
    ? new Date(currentTime.getTime() + timeRangeUnit)
    : currentTime;

  const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  // Bucket-based aggregates use their timestamp as the interval start.
  return timeRangeUnit
    ? `${formatTime(startTime)} - ${formatTime(endTime)}`
    : formatTime(currentTime);
}

// Match Otter's range routing. A one-week/month range uses hourly aggregates;
// the dashboard's one-day range uses fifteen-minute aggregates.
export function telemetryBucketDuration(range = "1d") {
  return (range === "1w" || range === "1m" ? 60 : 15) * 60 * 1000;
}
